export default [
    {
        path: '/fin-api/transactions-list',
        name: 'fin_api_transactions_list',
        component: () => import('@src/fin-api/fin-api-transactions-list.vue'),
        meta: {
            title: 'Kontoauszug Überweisung',
            role: 'ROLE_PAYMENT_MATCHING',
        },
    },
    {
        path: '/fin-api/transactions-list/managed-by-accounting',
        name: 'fin_api_transactions_list_managed_by_accounting',
        component: () => import('@src/fin-api/fin-api-transactions-list.vue'),
        props() {
            return {
                managedByAccounting: true,
            };
        },
        meta: {
            title: 'Kontoauszug Überweisung - Buchhaltung',
            role: 'ROLE_PAYMENT_MATCHING',
            favoriteRouteName: 'fin_api_transactions_list_managed_by_accounting',
        },
    },
    {
        path: '/fin-api/transaction-matching/:id',
        name: 'fin_api_transaction_matching',
        component: () => import('@src/fin-api/fin-api-transaction-matching.vue'),
        props(route: any) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Kontoauszugszuordnung Überweisung',
            role: 'ROLE_PAYMENT_MATCHING',
        },
    },
    {
        path: '/fin-api/transaction-matching/managed-by-accounting/:id',
        name: 'fin_api_transaction_matching_managed_by_accounting',
        component: () => import('@src/fin-api/fin-api-transaction-matching.vue'),
        props(route: any) {
            return {
                id: Number.parseInt(route.params.id),
                managedByAccounting: true,
            };
        },
        meta: {
            title: 'Kontoauszugszuordnung Überweisung',
            role: 'ROLE_PAYMENT_MATCHING',
        },
    },
    {
        path: '/fin-api/transaction-detail/:id',
        name: 'fin_api_transaction_detail',
        component: () => import('@src/fin-api/fin-api-transaction-detail.vue'),
        props(route: any) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Kontoauszugszeile Überweisung',
            role: 'ROLE_FIN_API_TRANSACTION',
        },
    },
    {
        path: '/fin-api/config',
        name: 'fin_api_config',
        component: () => import('@src/fin-api/fin-api.vue'),
        meta: {
            title: 'Fin-Api Konfiguration',
            role: 'ROLE_EDIT_FIN_API_CONFIG',
        },
    },
    {
        path: '/fin-api/custom-matching/create',
        name: 'fin_api_custom_matching_create',
        component: () => import('@src/fin-api/fin-api-custom-matching.vue'),
        meta: {
            title: 'Überweisung-Zuordnungsregel anlegen',
            role: 'ROLE_FIN_API_CUSTOM_MATCHING',
        },
    },
    {
        path: '/fin-api/custom-matching/list',
        name: 'fin_api_custom_matching_list',
        component: () => import('@src/fin-api/fin-api-custom-matching-list.vue'),
        meta: {
            title: 'Überweisung-Zuordnungsregeln',
            role: 'ROLE_FIN_API_CUSTOM_MATCHING',
        },
    },
    {
        path: '/fin-api/custom-matching/:id',
        name: 'fin_api_custom_matching_edit',
        component: () => import('@src/fin-api/fin-api-custom-matching.vue'),
        props(route: any) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Überweisung-Zuordnungsregel bearbeiten',
            role: 'ROLE_FIN_API_CUSTOM_MATCHING',
        },
    },
];
